/* GRAY TABS */ 
  $(document).ready(function () {
    $("ul.tabs").each(function () {
      var active,
        content,
        links = $(this).find("a");

      active = links.first().addClass("active");

      content = $(active.attr("href"));

      links.not(":first").each(function () {
        $($(this).attr("href")).hide();
      });

      $(this)
        .find("a")
        .click(function (e) {
          active.removeClass("active");

          content.hide();

          active = $(this);

          content = $($(this).attr("href"));

          active.addClass("active");

          content.show();

          return false;
        });
    });
  });


  /* TABS COLLECTION */ 

  $(document).ready(function () {
    $("ul.tabs-collection").each(function () {
      var active,
        content,
        links = $(this).find("a");

      active = links.first().addClass("active");
      content = $(active.attr("href"));
      links.not(":first").each(function () {
        $($(this).attr("href")).hide();
      });

      $(this)
        .find("a")
        .click(function (e) {
          active.removeClass("active");

          content.hide();

          active = $(this);

          content = $($(this).attr("href"));

          active.addClass("active");

          content.show();

          return false;
        });
    });
  });


  /* FAQ */ 

  $(document).ready(function () {
    $("ul.tabs-faq").each(function () {
      var active,
        content,
        links = $(this).find("a");

      active = links.first().addClass("active");
      content = $(active.attr("href"));
      links.not(":first").each(function () {
        $($(this).attr("href")).hide();
      });

      $(this)
        .find("a")
        .click(function (e) {
          active.removeClass("active");

          content.hide();

          active = $(this);

          content = $($(this).attr("href"));

          active.addClass("active");

          content.show();

          return false;
        });
    });
  });

/* INGREDIENTS TABS INSIDE PDP HYDRATION */ 
$(function () {

  var activeIndex = $('.product-grid .active-tab').index(),
      $contentlis = $('.product-grid .tabs-content li'),
      $tabslis = $('.product-grid .tabs li');
  
  // Show content of active tab on loads
  $contentlis.eq(activeIndex).show();

  $('.product-grid .tabs').on('click', 'li', function (e) {
    var $current = $(e.currentTarget),
        index = $current.index();
    
    $tabslis.removeClass('active-tab');
    $current.addClass('active-tab'); 
    $contentlis.hide().eq(index).show();
	 });   
});


/* INGREDIENTS TABS INSIDE PDP HYDRATION --- MOBILE */ 
$(function () {

  var activeIndexMobile = $('.custom-tabs-mobile .active-tab').index(),
      $contentlisMobile = $('.custom-tabs-mobile .tabs-content li'),
      $tabslisMobile = $('.custom-tabs-mobile .tabs li'); 
  
  // Show content of active tab on loads
  $contentlisMobile.eq(activeIndexMobile).show();

  $('.custom-tabs-mobile .tabs').on('click', 'li', function (e) {
    
    var $currentMobile = $(e.currentTarget),
        indexMobile = $currentMobile.index();
    
      console.log( "jamak" + indexMobile );

    $tabslisMobile.removeClass('active-tab');
    $currentMobile.addClass('active-tab');
    $contentlisMobile.hide().eq(indexMobile).show();
	 });   
});



$(document).on('click','.addproduct', function(){
  $('.addproduct').each( function(){

     //your code here
    }
 );
}
);


/* NUTRITIONAL TABS */ 
// reference from https://www.digitalocean.com/community/tutorials/js-tabs

const tabs = document.querySelectorAll(".tabNutrition");

function tabify(tab) {
  const tabList = tab.querySelector(".tab__list");

  if (tabList) {
    const tabItems = [...tabList.children];
    const tabContent = tab.querySelector(".tab__content");
    const tabContentItems = [...tabContent.children];
    let tabIndex = 0;

    tabIndex = tabItems.findIndex((item, index) => {
      return [...item.classList].indexOf("is--active") > -1;
    });

    tabIndex > -1 ? (tabIndex = tabIndex) : (tabIndex = 0);

    function setTab(index) {
      tabItems.forEach((x, index) => x.classList.remove("is--active"));
      tabContentItems.forEach((x, index) => x.classList.remove("is--active"));

      tabItems[index].classList.add("is--active");
      tabContentItems[index].classList.add("is--active");
    }

    tabItems.forEach((x, index) =>
      x.addEventListener("click", () => setTab(index))
    );
    setTab(tabIndex);
    tab.querySelectorAll(".tab").forEach((tabContent) => tabify(tabContent));
  }
}

tabs.forEach(tabify);







      var acc=document.getElementsByClassName("osmo-faq-question");
      for(var i=0;i<acc.length;i++){
          acc[i].addEventListener("click",function(){
          this.classList.toggle("active");var panel=this.nextElementSibling;
          if(panel.style.maxHeight){
              panel.style.maxHeight=null;
          }else{
              panel.style.maxHeight=panel.scrollHeight+"px";
          }
          });
      }
      
